import {Button, Card, Col, Divider, Form, message, Modal, Row, Space} from "antd";
import customerChangeRequestService from "../../../service/customerChangeRequestService";
import ErrorHandler from "../../../util/ErrorHandler";
import {useEffect, useState} from "react";
import {DownloadOutlined, EyeOutlined} from "@ant-design/icons";
import {DOC_CODE_OTHER_REQUEST, PREVIEW_DOC_TYPES} from "../../../util/Constants";
import {
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR,
    MSG_OTHER_REQUEST_HISTORY_LIST_FETCH_FAILURE_ERROR
} from "../../../util/Messages";
import TextArea from "antd/es/input/TextArea";
import {OtherRequestDto} from "../../../dto/OtherRequestDto";
import PreviewModalComp from "../../common/preview/PreviewModalComp";
import {UploadedDocumentDetailDto} from "../../../dto/UploadedDocumentDetailDto";
import documentService from "../../../service/documentService";
import Validation from "../../../util/Validation";
import ChangeRequestHistoryTableComp from "./changeRequestHistoryTableComp";


interface OtherRequestHistoryProp {
    cin: string
}

const OtherRequestHistoryComp = (props: OtherRequestHistoryProp) => {
    const [form] = Form.useForm();
    const [isLoading, setLoading] = useState(false);
    const [otherRequestHistoryList, setOtherRequestHistoryList] = useState<OtherRequestDto[]>()
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [otherRequestDocument, setOtherRequestDocument] = useState<UploadedDocumentDetailDto>();
    const [docURL, setDocURL] = useState('');
    const [previewOpen, setPreviewOpen] = useState(false);
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);
    const [documentName, setDocumentName] = useState<string>("");

    useEffect(() => {
        fetchOtherRequestHistory(props.cin)
    }, []);


    const fetchOtherRequestHistory = (cin: string) => {
        setLoading(true)
        customerChangeRequestService.getOtherRequestHistory(cin).then((res) => {
            if (res.data.results) {
                setOtherRequestHistoryList(res.data.results)
                setLoading(false)
            } else {
                message.error(MSG_OTHER_REQUEST_HISTORY_LIST_FETCH_FAILURE_ERROR)
                setLoading(false)
            }
        }).catch(reason => {
            ErrorHandler.handleError(reason)
            setLoading(false)
        })
    }

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const showModal = (record: OtherRequestDto) => {
        setIsModalOpen(true);
        setOtherRequestDocument(undefined)
        if (null != record.uploadDocumentDetailId) {
            documentService.getUploadDocumentListByTypeAndUploadedDocId(record.jobNo, record.uploadDocumentDetailId, [DOC_CODE_OTHER_REQUEST]).then(res => {
                if (res.data.status == 'SUCCESS') {
                    setOtherRequestDocument(res.data.results[0].uploadDocumentDetailDto);
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
            });
        }
        form.setFieldsValue({otherRequest: record.otherRequest})
    };

    const openModal = (document: UploadedDocumentDetailDto) => {
        documentService.viewOriginalDocument(document.uploadDocumentDetailId.toString()).then(res => {
            if (res.data !== null) {
                setPreviewOpen(true)
                setIsModalOpen(false)
                setDocURL(res.data.results)
                setDocType(Validation.checkDocumentContentType(res.data.results))
                setDocumentName(document.originalDocumentName)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
        return true;
    };

    const handlePreviewCancel = () => {
        setPreviewOpen(false);
    };

    const download = (val: string, docName: string) => {
        let a = document.createElement('a');
        a.href = val;
        a.download = docName;
        a.click();
    }
    return (
        <>
            <Row gutter={[24, 12]}>

                <Col span={24}>
                    <ChangeRequestHistoryTableComp tableData={otherRequestHistoryList} onShowModal={showModal}
                                                   loading={isLoading}/>
                </Col>
            </Row>
            <Modal title="Other Request History"
                   open={isModalOpen}
                   footer={null}
                   onCancel={handleCancel}
                   width={800}
                   centered
                   style={{top: 20, paddingBottom: 20}}
                   destroyOnClose={true}>
                <Row gutter={[24, 12]} className={'form-item-mb-12'} style={{marginTop: 18}}>
                    <Col span={24}>
                        <Card title="Request Details" size={'small'}>
                            <Form
                                className='form-input'
                                layout={"vertical"}
                                form={form}
                            >
                                <Row gutter={[12, 0]}>
                                    <Col span={24}>
                                        <Form.Item
                                            // label="Request"
                                            name={"otherRequest"}>
                                            <TextArea rows={4} disabled/>
                                        </Form.Item>
                                    </Col>
                                    {otherRequestDocument ? <Col span={24} style={{marginBottom: 16, paddingRight: 28}}>
                                        <div className='utility_bill img-nic'>
                                            <div className='utulity_bill_icon_div'>
                                                <div className="img_div">
                                                    <img src={otherRequestDocument?.thumbB64} alt=""/>
                                                </div>
                                                <div className='name_div'>
                                                    <h5>{otherRequestDocument?.documentTypeName}</h5>
                                                    {/*<h6>Size: 5MB </h6>*/}
                                                </div>
                                            </div>
                                            <Button className='doc-view-btn'
                                                    onClick={() => openModal(otherRequestDocument)}
                                            ><EyeOutlined/></Button>
                                        </div>
                                    </Col> : <></>}

                                </Row>
                            </Form>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Divider style={{marginBottom: 12}}></Divider>
                    </Col>
                    <Col span={24}>
                        <Space style={{float: 'right'}}>
                            <Button
                                    onClick={handleCancel}
                                    style={{
                                        width: 80,
                                    }}>Cancel</Button>
                        </Space>
                    </Col>
                </Row>

            </Modal>

            <Modal
                className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}
                open={previewOpen}
                centered
                title={documentName}
                onCancel={handlePreviewCancel}
                destroyOnClose={true}
                width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
                footer={[
                    <Button type="primary" icon={<DownloadOutlined/>} style={{background: '#FF7400', height: 40}}
                            htmlType="submit" onClick={() => download(docURL, documentName)}>
                        Download
                    </Button>]}>
                <PreviewModalComp docURL={docURL}/>
            </Modal>
        </>
    )
}
export default OtherRequestHistoryComp;